import React from "react";
import { Button } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const OutlinedButtonSmall = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Outlined Small button"}
        value={"<Button variant={\"outlined\"} size={'small'}>Small</Button>"}
      >
        <Button variant={"outlined"} size={"small"} color={"inherit"}>
          Small
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default OutlinedButtonSmall;
